// extracted by mini-css-extract-plugin
export default {"tabBar":"MobileTabBar_tabBar__s6dU+","tabItem":"MobileTabBar_tabItem__sKNNd","label":"MobileTabBar_label__79Gmc","active":"MobileTabBar_active__dCkE7"};